import { useGetAPMs, useGetUserAutocomplete } from "@api";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const Context = createContext({
  owners: [],
});

export const useWorkshopContext = () => useContext(Context);

export const WorkshopProvider = ({ children }) => {
  const [{ data: resultAmps }, getAmps] = useGetAPMs();
  const [{ data: ownersData, loading: loadingOwners }, getOwners] = useGetUserAutocomplete();

  const [owners, setOwners] = useState([]);
  const [amps, setAmps] = useState([]);

  useEffect(() => {
    getOwners({ permissions: ["filters.authors"] });
    getAmps();
  }, []);

  useEffect(() => {
    if (ownersData) {
      const tempOwner = [];
      ownersData.map((owner) => {
        owner.label = `${owner.firstName} ${owner.lastName}`;
        owner.value = owner._id;
        tempOwner.push(owner);
      });
      setOwners(tempOwner);
    }
  }, [ownersData]);

  useEffect(() => {
    if (resultAmps) {
      const social = [];
      resultAmps.data?.map((result) => {
        if (result.kind === "social") {
          result.label = result.name;
          result.value = result.key;
          social.push(result);
        }
      });
      setAmps(social);
    }
  }, [resultAmps]);

  const values = useMemo(
    () => ({
      amps,
      owners,
      loadingOwners,
    }),
    [owners, loadingOwners, amps]
  );

  return <Context.Provider value={values}>{children}</Context.Provider>;
};
